/* eslint-disable */
/**
 * 请求模块封装
 */
import 'whatwg-fetch';
import Cookies from 'js-cookie';
import { toLocale } from '@ok/blade';
import Storage from './Storage';
import util from './util';
import * as reqAwait from './reqAwait';

const Promise = require('promise');

function redirectLogin() {
  const { pathname, search, hash } = window.location;
  const forwardUrl = `${pathname}${search}${hash}`;
  window.location.href = `/account/login?logout=true&forward=${encodeURIComponent(
    forwardUrl
  )}`;
}

function _status(response) {
  if (response.status >= 200 && response.status < 300) {
    const newToken = response.headers.get('x-ok-token');
    if (newToken && newToken.length !== 0) {
      localStorage.setItem('token', newToken);
      // 临时兼容ont逻辑，后续会替换本模块
      Cookies.set('isLogin', 1, { expires: 7 });
    }
    return Promise.resolve(response);
  } else if (response.status === 401 || response.status === 403) {
    // 令牌无效 跳转登录
    // alert('req+' + response.config.url);
    Storage.remove('token');
    Cookies.remove('isLogin');
    redirectLogin();
    return Promise.resolve(response);
  }

  return Promise.reject(new Error(response.statusText));
}

function _error(e) {
  console.error(e, e.message);
}

function _doFetch(url, paramObj, successCallback, errorCallback) {
  // .then(_status)
  fetch(url, paramObj)
    .then(_status)
    .then((result) => {
      return result.json();
    })
    .then((data) => {
      // success
      if (data && data.code === 0) {
        successCallback && successCallback(data);
      } else if (data && data.code === 800) {
        // alert('req+' + url);
        // 令牌失效 跳转登录
        Storage.remove('token');
        Cookies.remove('isLogin');
        redirectLogin();
      }
      // fail 处理各种状态码 TO DO
      else {
        errorCallback && errorCallback(data);
      }
    })
    .catch((data) => {
      const errorText = toLocale('serverError');
      data = {};
      data.msg = errorText;
      data.message = errorText;
      errorCallback && errorCallback(data);
    });
}

/**
 * get 请求
 * @param url
 * @param params
 * @param successCallback
 * @param errorCallback
 * @param notNeedAuthorization  header不需要Authorization  默认需要
 * @param needDeviceId          header需要 user_deviceId  默认不需要  登录注册接口需要
 * @param token                 从外部传入的 token  二步验证接口需要从外部传
 */
export function getData(
  url,
  params,
  successCallback,
  errorCallback,
  notNeedAuthorization,
  needDeviceId,
  token
) {
  // 兼容不传递params的模式(url, successCallback, errorCallback)
  if (typeof params === 'function') {
    errorCallback = successCallback;
    successCallback = params;
    params = {};
  }
  const queryString = util.objToQueryString(params);
  if (queryString) {
    url += url.indexOf('?') > 0 ? `&${queryString}` : `?${queryString}`;
  }

  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'App-Type': 'web',
  };

  header.devId = util.getDeviceId();
  header.loginName = Storage.get('loginName') || '';

  const sendReq = () => {
    const paramObj = {
      method: 'GET',
      headers: header,
      credentials: 'include',
    };
    _doFetch(url, paramObj, successCallback, errorCallback);
  };

  if (!notNeedAuthorization) {
    // Fix referral App page
    if (
      // window.location.pathname === "/account/referral" &&
      navigator.userAgent.includes('OKApp')
    ) {
      window.jsbridge.getToken().then((appToken) => {
        if (appToken) {
          localStorage.setItem('token', appToken);
          header.Authorization = appToken;
        }
        sendReq();
      });
    } else {
      header.Authorization = token || Storage.get('token') || '';
      sendReq();
    }
  } else {
    sendReq();
  }
}

export function delData(url, params, successCallback, errorCallback) {
  if (typeof params === 'function') {
    errorCallback = successCallback;
    successCallback = params;
    params = {};
  }
  const queryString = util.objToQueryString(params);
  if (queryString) {
    url += url.indexOf('?') > 0 ? `&${queryString}` : `?${queryString}`;
  }
  const paramObj = {
    method: 'DELETE',
    headers: {
      Authorization: Storage.get('token') || '',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'App-Type': 'web',
    },
    credentials: 'include',
  };
  _doFetch(url, paramObj, successCallback, errorCallback);
}

export function doPostData(
  url,
  params,
  successCallback,
  errorCallback,
  inData
) {
  let paramObj = {};
  const formData = new FormData();
  for (const k in params) {
    formData.append(k, params[k]);
  }
  if (!inData) {
    paramObj = {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        Authorization: Storage.get('token') || '',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'App-Type': 'web',
      },
      credentials: 'include',
    };
  } else {
    paramObj = {
      method: 'POST',
      body: formData,
      headers: {
        Authorization: Storage.get('token') || '',
        'App-Type': 'web',
      },
      credentials: 'include',
    };
  }
  _doFetch(url, paramObj, successCallback, errorCallback);
}

export function doPutData(url, params, successCallback, errorCallback, inData) {
  let paramObj = {};
  const formData = new FormData();
  for (const k in params) {
    formData.append(k, params[k]);
  }
  if (!inData) {
    paramObj = {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: {
        Authorization: Storage.get('token') || '',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'App-Type': 'web',
      },
      credentials: 'include',
    };
  } else {
    paramObj = {
      method: 'PUT',
      body: formData,
      headers: {
        Authorization: Storage.get('token') || '',
        'App-Type': 'web',
      },
      credentials: 'include',
    };
  }
  _doFetch(url, paramObj, successCallback, errorCallback);
}

/**
 * post 请求
 * @param url
 * @param params
 * @param successCallback
 * @param errorCallback
 * @param notNeedAuthorization  header不需要Authorization  默认需要
 * @param needDeviceId          header需要 devId  默认不需要  登录注册接口需要
 * @param sync          是否同步，默认异步
 */
export function postData(
  url,
  params,
  successCallback,
  errorCallback,
  notNeedAuthorization,
  needDeviceId,
  sync
) {
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'App-Type': 'web',
  };

  if (!notNeedAuthorization) {
    header.Authorization = Storage.get('token') || '';
  }
  header.devId = util.getDeviceId();
  header.loginName = Storage.get('loginName') || '';
  const paramObj = {
    async: !sync,
    method: 'POST',
    body: JSON.stringify(params),
    headers: header,
    credentials: 'include',
  };
  _doFetch(url, paramObj, successCallback, errorCallback);
}

/**
 * post 请求 with token param
 * @param url
 * @param params
 * @param successCallback
 * @param errorCallback
 * @param token
 */
export function postDataJp(url, params, successCallback, errorCallback, token) {
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'App-Type': 'web',
  };
  header.Authorization = token;
  header.devId = util.getDeviceId();
  header.loginName = Storage.get('loginName') || '';
  const paramObj = {
    method: 'POST',
    body: JSON.stringify(params),
    headers: header,
    credentials: 'include',
  };
  _doFetch(url, paramObj, successCallback, errorCallback);
}

export function fetchData(url, params, conf, successCallback, errorCallback) {
  conf = conf || {};
  fetch(url, {
    method: conf.method || 'POST',
    body: conf.isQueryData
      ? util.objToQueryString(params)
      : JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      'App-Type': 'web',
    },
    credentials: conf.credentials || 'same-origin',
  })
    .then((result) => {
      return result.json();
    })
    .then((data) => {
      // always
      callback && callback.always && callback.always(data);
      // success
      if (data && +data.code === 0) {
        callback && callback.success && callback.success(data);
      }
      // fail
      else {
        callback && callback.fail && callback.fail(data);
      }
    })
    .catch(_error); // errorCallback && errorCallback();
}

export function download(url, data) {
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'App-Type': 'web',
  };
  // 兼容注册登录 登录注册需要 devId
  header.Authorization = Storage.get('token') || '';
  header.loginName = Storage.get('loginName') || '';

  if (data) {
    let query = '';

    Object.keys(data).forEach((key, i) => {
      const kv = `${key}=${data[key]}`;
      query += (i > 0 ? '&' : '?') + kv;
    });

    url += query;
  }

  return fetch(url, {
    method: 'GET',
    headers: header,
    credentials: 'include',
  }).then((response) => {
    return response.blob();
  });
}

export const postDataPromise = (url, params) => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  };
  return fetch(url, options)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data.json();
    });
};

export const getDataPromise = (url, params) => {
  return new Promise((resolve, reject) => {
    const header = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'App-Type': 'web',
    };

    // 参数解析
    let paramsStr = '';
    if (params) {
      const paramKeys = Object.keys(params);
      paramKeys.forEach((item, index) => {
        if (index === 0) {
          paramsStr += `?${item}=${params[item]}`;
        } else {
          paramsStr += `&${item}=${params[item]}`;
        }
      });
    }

    header.Authorization = Storage.get('token') || '';
    header.devId = util.getDeviceId();
    header.loginName = Storage.get('loginName') || '';
    const paramObj = {
      method: 'GET',
      headers: header,
      credentials: 'include',
    };
    // return fetch(url + paramsStr, paramObj).then((res) => {
    //   return res.json();
    // });
    if (navigator.userAgent.includes('OKApp')) {
      window.jsbridge.getToken().then((appToken) => {
        if (appToken) {
          localStorage.setItem('token', appToken);
          paramObj.headers.Authorization = appToken;
        }
        resolve(
          fetch(url + paramsStr, paramObj).then((res) => {
            return res.json();
          })
        );
      });
    } else {
      resolve(
        fetch(url + paramsStr, paramObj).then((res) => {
          return res.json();
        })
      );
    }
  });
};

export const getAsync = reqAwait.getAsync;
export const postAsync = reqAwait.postAsync;

/**
 * Promisify getData helper
 * Converts callback-based getData to Promise
 * @param {string} url - API endpoint
 * @returns {Promise} Promise resolving to response
 */
export function getDataAsync(url) {
  return new Promise((resolve, reject) => {
    getData(url, resolve, reject);
  });
}

/**
 * Promisify postData helper
 * Converts callback-based postData to Promise
 * @param {string} url - API endpoint
 * @param {Object} data - Request payload
 * @returns {Promise} Promise resolving to response
 */
export function postDataAsync(url, data) {
  return new Promise((resolve, reject) => {
    postData(url, data, resolve, reject);
  });
}
